(() => {
  const updateLink = (link) => {
    if (!link || !link.hasAttribute('href')) return;
    const url = new URL(link.getAttribute('href'), window.location.href);
    if (url.origin !== window.location.origin || !/\/collections\/[^/]+/.test(url.pathname)) return;
    url.searchParams.set('filter.v.availability', '1');
    link.href = url.href;
  };
  const updateLinks = () => document.querySelectorAll('a[href]').forEach(updateLink);
  document.addEventListener('click', (event) => {
    if (event.target instanceof Element) updateLink(event.target.closest('a[href]'));
  }, true);
  document.addEventListener('collection:rerendered', updateLinks);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateLinks, { once: true });
  } else {
    updateLinks();
  }
})();
